import { render, staticRenderFns } from "./cardexample.vue?vue&type=template&id=5d4a6e94&scoped=true&"
import script from "./cardexample.vue?vue&type=script&lang=js&"
export * from "./cardexample.vue?vue&type=script&lang=js&"
import style0 from "./cardexample.vue?vue&type=style&index=0&id=5d4a6e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a6e94",
  null
  
)

export default component.exports